export const buildUpdatedProjectTasks = ({
  existingTasks,
  newTask,
  insertIndex,
}) => {
  const tasksBeforeInsert = existingTasks.slice(0, insertIndex);
  const tasksAfterInsert = existingTasks
    .slice(newTask.position)
    .map((task) => ({
      ...task,
      position: task.position + 1,
    }));

  return [...tasksBeforeInsert, newTask, ...tasksAfterInsert];
};

export const combineExistingTasksWithNewTask = ({ newTask, existingTasks }) => {
  return newTask
    ? [
        ...existingTasks.slice(0, newTask.index),
        newTask,
        ...existingTasks.slice(newTask.index),
      ]
    : existingTasks;
};

// Step 1 of rearranging.
// Removes the task that is moving and updates the position of the tasks that follow by -1
export const removeTaskandReindex = ({ removeIndex, tasks }) => {
  if (removeIndex === -1) {
    return tasks;
  }

  return tasks
    .filter((_, index) => index !== removeIndex)
    .map((task, index) => ({
      ...task,
      position: index >= removeIndex ? task.position - 1 : task.position,
    }));
};

// Step 2 of rearranging
// Inserts the task that was moved to the new position and updates the position of the tasks that follow by +1
export const insertTaskAndReindex = ({ updatedTask, insertIndex, tasks }) => {
  // If insertIndex is -1, it means the task was moved to the end of the list
  if (insertIndex === -1) {
    return [...tasks, updatedTask];
  }

  const tasksAfterInsert = tasks
    .splice(insertIndex)
    .map((task) => ({ ...task, position: task.position + 1 }));
  return [...tasks, updatedTask, ...tasksAfterInsert];
};
